import React, { Fragment } from "react";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";

/**
 * DeckImageCarousel component
 * @param {Object} data - The data for the carousel
 * @returns {JSX.Element} - Rendered component
 */
const DeckImageCarousel = ({ data }) => {
    /**
     * Function to clone logo cards
     * @param {Array} cards - The array of cards to clone
     * @returns {Array} - The cloned array of cards
     */
    const cloneLogoCards = (cards) => {
        const numberOfRepeats = Math.ceil(50 / (cards?.length ?? 1));
        const clonedDataSet = Array.from({ length: numberOfRepeats }, () => cards).flat();
        return clonedDataSet;
    };

    const { customId, title, additionalConfiguration, cardItems = [], cardCollections = [] } = data ?? {};
    const sectionSpacingClassName = getSpacingClassName(
        additionalConfiguration,
        "pt-15.5 pb-12.5 mt-5.25 lg:pt-[83px] lg:pb-[90px] lg:mt-20"
    );
    const marginTop = additionalConfiguration?.spacingTop?.marginDesktop;

    return (
        <section
            className={`logo-carousel overflow-hidden relative before:content-empty before:w-[100px] before:h-0.5 before:absolute before:bg-green before:top-0 before:left-0 before:right-0 before:m-auto ${sectionSpacingClassName} ${
                marginTop === "None" ? "before:hidden" : ""
            }`}
            id={customId}
        >
            <div key={customId}>
                {title && (
                    <h2 className="max-w-[1200px] px-3.75 m-auto text-center text-blue mb-9.5 lg:mb-14.25">{title}</h2>
                )}
                {/* prioritizing cardCollections against cardItems */}
                {cardCollections?.length > 0 ? (
                    cardCollections?.map((collection, collectionIndex) => (
                        <div
                            key={`${collection?.id}_${collectionIndex}`}
                            className={`inline-flex logo-list ${
                                collectionIndex % 2 === 0 ? "animate-slider-rtl" : "animate-slider-ltr"
                            } ${cardCollections?.length > 1 && collectionIndex > 0 ? "mt-5 md:mt-10" : ""}`}
                        >
                            {cloneLogoCards(collection?.cardItems)?.map((logo, index) => (
                                <Fragment key={`${logo?.id}_${index}`}>
                                    {logo?.media?.[0] && <Media media={logo?.media?.[0]} lazyLoad={false} />}
                                </Fragment>
                            ))}
                        </div>
                    ))
                ) : (
                    <div
                        className="inline-flex animate-[slideLogo_100s_infinite_linear] motion-reduce:![animation-play-state:paused] motion-reduce:hover:![animation-play-state:running] logo-list"
                        aria-hidden="true"
                    >
                        {cloneLogoCards(cardItems)?.map((logo, index) => (
                            <Fragment key={`${logo?.id}_${index}`}>
                                {logo?.media?.[0] && <Media media={logo?.media?.[0]} lazyLoad={false} />}
                            </Fragment>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default DeckImageCarousel;
